import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { formatMoney, AFGHAN_MONTHS } from '../utils/api';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const now = new Date();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();
  const shamsiYear = year - 621;

  useEffect(() => {
    const load = async () => {
      try {
        const [salesRes, loansRes, productsRes, expensesRes] = await Promise.all([
          api.get(`/sales/report/monthly?month=${month}&year=${year}`),
          api.get('/loans'),
          api.get('/products'),
          api.get(`/expenses?month=${month}&year=${year}`)
        ]);
        const activeLoans = loansRes.data.filter(l => l.status !== 'paid');
        const totalDebt = activeLoans.reduce((s, l) => s + Number(l.remaining_amount), 0);
        const lowStock = productsRes.data.filter(p => Number(p.stock) <= Number(p.min_stock));
        const totalExpenses = expensesRes.data.reduce((s, e) => s + Number(e.amount), 0);
        setStats({
          sales: salesRes.data.summary,
          totalDebt,
          activeLoans: activeLoans.length,
          lowStock: lowStock.length,
          totalExpenses,
          recentLoans: loansRes.data.slice(0, 5),
          topProducts: salesRes.data.topProducts
        });
      } catch {}
      setLoading(false);
    };
    load();
  }, [month, year]);

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>در حال بارگذاری...</div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>داشبورد</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 4 }}>
            {AFGHAN_MONTHS[now.getMonth()]} {shamsiYear} — گزارش این ماه
          </p>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/sales/new')}>
          ➕ فروش جدید
        </button>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">🛒</div>
          <div className="stat-label">فروش این ماه</div>
          <div className="stat-value">{stats?.sales?.total_sales || 0}</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">💰</div>
          <div className="stat-label">درآمد این ماه</div>
          <div className="stat-value" style={{ fontSize: 16 }}>{formatMoney(stats?.sales?.total_revenue)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">💳</div>
          <div className="stat-label">مجموع وام فعال</div>
          <div className="stat-value" style={{ fontSize: 16, color: 'var(--danger)' }}>{formatMoney(stats?.totalDebt)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">💼</div>
          <div className="stat-label">مصارف شرکا</div>
          <div className="stat-value" style={{ fontSize: 16, color: 'var(--warning)' }}>{formatMoney(stats?.totalExpenses)}</div>
        </div>
        {stats?.lowStock > 0 && (
          <div className="stat-card" style={{ borderRight: '3px solid var(--danger)' }}>
            <div className="stat-icon">⚠️</div>
            <div className="stat-label">محصولات کم موجودی</div>
            <div className="stat-value" style={{ color: 'var(--danger)' }}>{stats.lowStock}</div>
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <div className="card">
          <div className="card-header">
            <h3>وام‌های اخیر</h3>
            <button className="btn btn-outline btn-sm" onClick={() => navigate('/loans')}>همه</button>
          </div>
          {stats?.recentLoans?.length ? (
            <div>
              {stats.recentLoans.map(loan => (
                <div key={loan.id} onClick={() => navigate(`/loans/${loan.id}`)}
                  style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0',
                  borderBottom: '1px solid var(--border)', cursor: 'pointer' }}>
                  <span style={{ fontWeight: 500 }}>{loan.first_name} {loan.last_name}</span>
                  <span className={`badge ${loan.status === 'paid' ? 'badge-success' : 'badge-danger'}`}>
                    {formatMoney(loan.remaining_amount)}
                  </span>
                </div>
              ))}
            </div>
          ) : <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '20px 0' }}>وام فعالی وجود ندارد</p>}
        </div>

        <div className="card">
          <div className="card-header">
            <h3>پرفروش‌ترین محصولات</h3>
          </div>
          {stats?.topProducts?.length ? (
            <div>
              {stats.topProducts.map((p, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between',
                  padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                  <span>{p.name}</span>
                  <span style={{ color: 'var(--primary)', fontWeight: 500 }}>{formatMoney(p.total_revenue)}</span>
                </div>
              ))}
            </div>
          ) : <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '20px 0' }}>داده‌ای وجود ندارد</p>}
        </div>
      </div>
    </div>
  );
}
